// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class EnNewView extends JQueryView {
  maxStakeholders: number;

  constructor(maxStakeholders: number) {
    super('.company.stockholder_meetings.stockholders.en_new');
    this.maxStakeholders = maxStakeholders;
    this.render();
  }

  @on({ event: 'change', selector: 'input[name="all_checked"]' })
  onChangeAllCheck() {
    const allChecked = $('input[name="all_checked"]').prop('checked');
    if (allChecked) {
      $('input[type=checkbox]').prop('checked', true);
    } else {
      $('input[type=checkbox]').prop('checked', false);
    }
  }

  @on({ event: 'change', selector: 'input[type=checkbox]' })
  onChangeCheckbox(event: any) {
    const target = $(event.target);
    const id = target[0].id.replace(/[^0-9]/g, '');
    const send_at_english = target.prop('checked');

    if (send_at_english) {
      $(
        '#officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_' +
          id +
          '_locale',
      ).val('en');
    } else {
      $(
        '#officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_' +
          id +
          '_locale',
      ).val('ja');
    }
    this.render();
  }

  // 選択した株主数が上限を超えたらダイアログを表示する
  @on({ event: 'click', selector: '#confirm_btn' })
  onClickConfirmBtn(event: any) {
    const stakholders = $(
      'input:checkbox:checked[id^="officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_"]',
    );
    const isElectricSendCount = Number($('#is_electric_send_count').val());
    if (stakholders.length + isElectricSendCount - this.maxStakeholders > 0) {
      $('#plan_change_modal').modal();
      event.preventDefault();
    }
  }

  render() {
    const isElectricSendCount = Number($('#is_electric_send_count').val());
    const selectedCount = $(
      'input:checkbox:checked[id^="officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_"]',
    ).length;
    const totalCount = $(
      'input:checkbox[id^="officer_approval_stockholder_meeting_officer_approval_stakeholders_attributes_"]',
    ).length;

    if (totalCount - selectedCount > 0 || totalCount == 0) {
      $('input[name="all_checked"]').prop('checked', false);
    } else if (totalCount == selectedCount) {
      $('input[name="all_checked"]').prop('checked', true);
    }
    $('.selected-counts').text(`${selectedCount + isElectricSendCount}`);
  }
}
